import { useRestfulWrapper } from '~/hooks/useRestfulWrapper';
export default function RestfulWrapper(props) {
    const { initialData, fetch, renderChild, renderError, getStoreLocation, renderLoader, initialArgs } = props;
    const { renderRestfulState } = useRestfulWrapper({
        initialData,
        getStoreLocation,
        fetch,
        initialArgs
    });
    return renderRestfulState({
        renderChild,
        renderError,
        renderLoader
    });
}
